document.querySelectorAll('.h3p-pages-carousel').forEach((carousel) => {

    const viewport = carousel.querySelector('[data-carousel-viewport]');
    const previous = carousel.querySelector('[data-carousel-previous]');
    const next = carousel.querySelector('[data-carousel-next]');

    if (!viewport || !previous || !next) return;

    const cards = viewport.querySelectorAll('.h3p-pages-carousel__card');

    const getStep = () => {
        const firstCard = viewport.querySelector('.h3p-pages-carousel__card');

        if (!firstCard) {
            return viewport.clientWidth;
        }

        const track = viewport.querySelector('.h3p-pages-carousel__track');
        const styles = track ? window.getComputedStyle(track) : null;
        const gap = styles
            ? parseFloat(styles.columnGap || styles.gap || '0')
            : 0;

        return firstCard.getBoundingClientRect().width + gap;
    };

    const getVisibleCards = () => {
        if (window.innerWidth >= 900) {
            return 3;
        }

        if (window.innerWidth >= 640) {
            return 2;
        }

        return 1;
    };

    const updateArrowsVisibility = () => {
        const visibleCards = getVisibleCards();
        const show = cards.length > visibleCards;

        previous.hidden = !show;
        next.hidden = !show;
    };

    const updateButtons = () => {
        const maxScroll = viewport.scrollWidth - viewport.clientWidth;

        previous.disabled = viewport.scrollLeft <= 2;
        next.disabled = viewport.scrollLeft >= maxScroll - 2;
    };

    const reducedMotion = () =>
        window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    previous.addEventListener('click', () => {
        viewport.scrollBy({
            left: -getStep(),
            behavior: reducedMotion() ? 'auto' : 'smooth',
        });
    });

    next.addEventListener('click', () => {
        viewport.scrollBy({
            left: getStep(),
            behavior: reducedMotion() ? 'auto' : 'smooth',
        });
    });

    viewport.addEventListener('scroll', updateButtons, {
        passive: true,
    });

    window.addEventListener('resize', () => {
        updateArrowsVisibility();
        updateButtons();
    });

    updateArrowsVisibility();
    updateButtons();

});